import type { AuthorizedMediaItem, DriveAuthSession, DriveFile } from '../types';
import { uploadLocalFileToDrive } from './driveService';

export const buildLocalContentKey = (hash: string, sizeBytes: number): string =>
  `${hash}:${sizeBytes}`;

export const shouldShowSignOutExportModal = (hasNewLocalUploadsThisSession: boolean): boolean =>
  hasNewLocalUploadsThisSession;

export interface LocalSyncPayload {
  fileId: string;
  name: string;
  mimeType: string;
  thumbnailLink?: string;
  source: 'drive';
  contentHash: string;
  sizeBytes: number;
  originalSource: 'local';
}

export const makeDriveBackedLocalPayload = (
  driveFile: DriveFile,
  contentHash: string,
  sizeBytes: number,
): LocalSyncPayload => ({
  fileId: driveFile.id,
  name: driveFile.name,
  mimeType: driveFile.mimeType,
  thumbnailLink: driveFile.thumbnailLink,
  source: 'drive',
  contentHash,
  sizeBytes,
  originalSource: 'local',
});

interface SyncLocalFileParams {
  session: DriveAuthSession;
  file: File;
  contentHash: string;
  mimeType: string;
  upsertLibrary: (
    session: DriveAuthSession,
    items: Omit<AuthorizedMediaItem, 'addedAt'>[],
  ) => Promise<unknown>;
}

export const syncLocalFileToDriveAndLibrary = async ({
  session,
  file,
  contentHash,
  mimeType,
  upsertLibrary,
}: SyncLocalFileParams): Promise<LocalSyncPayload> => {
  const driveFile = await uploadLocalFileToDrive(session.accessToken, file, {
    contentHash,
    mimeType,
  });
  const payload = makeDriveBackedLocalPayload(driveFile, contentHash, file.size);
  await upsertLibrary(session, [payload]);
  return payload;
};
